import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import CodeusErrorBoundary from 'src/components/CodeusErrorBoundary';
import useAuth from 'src/hooks/useAuth';
import AuditLogPage from 'src/routes/AuditLogPage';
import ClassifierSettings from 'src/routes/settings/classifiers/ClassifierSettings';
import ConnectorSettings from 'src/routes/settings/ConnectorSettings';
import DataSettings from 'src/routes/settings/DataSettings';
import EmailSettings from 'src/routes/settings/EmailSettings';
import UserSettings from 'src/routes/settings/UserSettings';
import PolicyEngineRoute from './PolicyEngineRoute';

export default function SettingsPage(): React.ReactElement {
	const { auth } = useAuth();
	if (!auth) return null;
	const isAdmin = auth?.isFullAdmin();

	const redirectUrl = isAdmin ? '/settings/connectors' : '/settings/manage';

	return (
		<CodeusErrorBoundary>
				<Routes>
					{isAdmin && (
						<>
							<Route
								path="connectors"
								element={<ConnectorSettings />}
							/>
							<Route
								path="policy"
								element={<PolicyEngineRoute />}
							/>
							<Route
								path="classifiers"
								element={<ClassifierSettings />}
							/>
							<Route
								path="notifications"
								element={<EmailSettings />}
							/>
							<Route path="users" element={<UserSettings />} />
							<Route path="auditing" element={<AuditLogPage />} />
						</>
					)}
					<Route path="manage" element={<DataSettings />} />
					<Route
						path="*"
						element={<Navigate to={redirectUrl} replace />}
					/>
				</Routes>
		</CodeusErrorBoundary>
	);
}
